// extracted by mini-css-extract-plugin
export default {"checkbox":"responsiveStyles_checkbox__1UClE","checked":"responsiveStyles_checked__AjOiu","notice":"responsiveStyles_notice__33nD3"};